import { Component, NgZone, AfterViewInit, Output, Input, EventEmitter, ChangeDetectorRef, OnInit, ViewChild, ElementRef } from '@angular/core';
import { environment } from '../../../environments/environment';
import { View, Feature, Map } from '../../../../node_modules/ol';
import { Coordinate } from '../../../../node_modules/ol/coordinate';
import { ScaleLine, defaults as DefaultControls } from '../../../../node_modules/ol/control';
import proj4 from '../../../../node_modules/proj4';
import Projection from '../../../../node_modules/ol/proj/Projection';
import VectorLayer from '../../../../node_modules/ol/layer/Vector';
import TileLayer from '../../../../node_modules/ol/layer/Tile';
import TileGrid from '../../../../node_modules/ol/tilegrid/TileGrid';
//import {getBottomLeft, getTopRight} from 'ol/extent';
import format from '../../../../node_modules/ol/format/GeoJSON';
import { register } from '../../../../node_modules/ol/proj/proj4';
import { get as GetProjection } from 'ol/proj';
import TileWMS from '../../../../node_modules/ol/source/TileWMS';
import {OSM, TileArcGISRest} from 'ol/source';
import { Extent } from 'ol/extent';
import { ActivatedRoute } from '@angular/router';
import { MapService } from '../../shared/services/map.service'
import { FrostmeasurementService } from '../../shared/services/frostmeasurement.service'
import VectorSource from 'ol/source/Vector';
import Select from 'ol/interaction/Select';
import { SelectEvent } from 'ol/interaction/Select';
import SelectEventType from 'ol/interaction/Select';
import { altKeyOnly, click, pointerMove } from 'ol/events/condition';
import { IFrostMeasurementStation } from '../../interfaces/IFrostMeasurementStation';
import Point from 'ol/geom/Point';
import { OlMapSymbol } from './olmapsymbol';
import { OlUtils } from './olUtils';
import * as olExtent from 'ol/extent';
import GeoJSON from 'ol/format/GeoJSON';
import { olMapEventService } from '../../shared/services/olEventEmitter.service';
import { stationListEventService } from '../../shared/services/stationlistEventEmitterService';
import { fromEvent, Observable, Subscription } from "rxjs";
import { debounceTime } from 'rxjs/operators'
import { Attribution, defaults as defaultControls } from 'ol/control';
import { AttributionLike } from 'ol/source/Source';


//import { title } from 'node:process';

//https://medium.com/runic-software/a-simple-guide-to-openlayers-in-angular-b10f6feb3df1

@Component({
  selector: 'app-ol-map',
  templateUrl: './olmap.component.html',
  styleUrls: ['./olmap.component.scss']
})
export class olmapComponent implements AfterViewInit, OnInit {
  @ViewChild('map') mapDiv: ElementRef;
  @Input() center: Coordinate;
  @Input() zoom: number;
  view: View;
  //projection: Projection;
  mapurl: string;
  wmsParams:object;
 mapserverurl: string;

  mapextent: Extent = [-300840, 5900000, 962167, 8110000];
  frostmeasurementstations: IFrostMeasurementStation[];
  Map: Map;
  selectInteraction: Select;
  selectedId: number;
  selectedFeatures: any;
  tjalesource: VectorSource;
  @Output() mapReady = new EventEmitter<Map>();
  private symbolUrl = environment.symbolURL;

  resizeObservable$: Observable<Event>
  resizeSubscription$: Subscription
  olutils = new OlUtils();
  interval: any;

  constructor(private zone: NgZone, private cd: ChangeDetectorRef, private route: ActivatedRoute, private mapService: MapService, private frostmeasurementService: FrostmeasurementService, private olmapselection: olMapEventService, private stationlistselection: stationListEventService) { }


  ngOnInit(): void {

    this.resizeObservable$ = fromEvent(window, 'resize')
    this.resizeSubscription$ = this.resizeObservable$.pipe(debounceTime(500)).subscribe(evt => {
      var height = window.innerHeight;
      this.mapDiv.nativeElement.style.height = (height - 130).toString() + 'px';
      //document.getElementById('stationlist').style.height = (height - 340).toString() + 'px';  
      this.Map.updateSize();

    });
    //Subscribe to Event from selection i nList
    if (this.stationlistselection.subsVar == undefined) {
      this.stationlistselection.subsVar = this.stationlistselection.invokeListSelection.subscribe((maetpunktid: number) => {
        this.onselectStationfromListorUpdate(maetpunktid);
      });
    }
    //Subscribe to Event from selection in Map
    if (this.olmapselection.updatesubsVar == undefined) {
      this.olmapselection.updatesubsVar = this.olmapselection.invokeMapSelection.subscribe((measurementId: number) => {
        this.selectedId = measurementId;
        console.log('UpdateStationList: ' + Date().toString());
      });
    }
  }

  ngAfterViewInit(): void {
    this.getmapURL();
  
  }

  ngOnDestroy() {
    this.resizeSubscription$.unsubscribe()
  }

  mapurlObservable = {
    next: (res: string) => {
      this.mapurl = res.toString();
      this.getwmsParams();
     // this.initializeMap();
    },
    error: (e: Error) => console.log("mapurl not   retrieved" + e),
    complete: () => console.log("mapurl retrieved")
  };

  wmsparamsObservable = {
    next: (res: string) => {
      this.wmsParams = JSON.parse (res.toString());
      this.initializeMap();
    },
    error: (e: Error) => console.log("wmsparams not   retrieved" + e),
    complete: () => console.log("wmsparams retrieved")
  };

  public getmapURL() {
    this.mapService.get('MapUrl')
      .subscribe(this.mapurlObservable);
  }

  public getwmsParams() {
    this.mapService.get('WmsParams')
      .subscribe(this.wmsparamsObservable);
  }

  public initializeMap() {
    if (!this.Map) {
      this.zone.runOutsideAngular(() => this.initMap())
    }
    setTimeout(() => this.mapReady.emit(this.Map), 1);
    window.dispatchEvent(new Event('resize'));
    this.interval = setInterval(() => {
      this.getStationDatafromServer();;
    }, 60 * 1000);
  }

  private handleError(error: any) {
    let errMsg = (error.message) ? error.message : error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    return errMsg;
  }

  private initMap(): void {
   
    let wmsparams: object = this.wmsParams != undefined && this.wmsParams != null ? this.wmsParams :  { 'VERSION': '1.1.1', 'LAYERS': 'Norden', 'FORMAT': 'image/png', 'TRANSPARENT': false, 'NAME': 'Nordenkartan', 'TILED': true };
    let url: string = this.mapurl != undefined && this.mapurl != '' ? this.mapurl :  'https://bas.gis.trafikverket.local/arcgis/rest/services/Basemap/BakgrundskartaNorden/MapServer';
   
    this.mapextent = [-850284, 5810671, 1902167, 9110000];
    this.center =  [460000, 6400000];

    //Behövs för att ScaleLine-kontroller skall fungera, kan tas bort annars.
    proj4.defs("EPSG:3006", "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs");
    
    register(proj4)
    let proj_sweref99tm: Projection = new Projection({
      code: 'EPSG:3006',
      units: 'm',
      getPointResolution: function (r) { return r; }
    });

    proj_sweref99tm.setExtent(this.mapextent);    
    
    //Extent och scales
    var scales = [12000000, 10000000, 8000000, 6000000, 4000000, 2000000, 1000000, 500000, 250000, 100000, 50000, 25000, 10000, 5000];
    var resolutions = this.olutils.calculateResolutions(scales);
   /*  let tileGrid: TileGrid = new TileGrid({
      extent: this.mapextent,
      minZoom: 0,
      resolutions: resolutions,
      origin: [150000, 5500000]
    }); */

    var maxbounds = [
      -850284, 5810671,
      1902167, 9110000];

  /*   this.view = new View({
      center: this.center,
      zoom: this.zoom,
      projection: proj_sweref99tm,
    }); */

    const wmsAttribution: AttributionLike ="©<a href= 'https://www.openstreetmap.org/copyright' target='_blank'/>OpenStreetMap</a> contributors";

    /* var wmsLayer = new TileLayer({
      extent: this.mapextent,
      source: new TileWMS({
        attributions: wmsAttribution,
        attributionsCollapsible: false,
        url: url,
        params: wmsparams,
        hidpi: true,
        crossOrigin: null,
        tileGrid: tileGrid
      })
    }); */

    const mapserverLayer=  new TileLayer({
      extent:this.mapextent,
      source: new TileArcGISRest({
          attributions: wmsAttribution,       
          url: url
      })
  });

    this.tjalesource = new VectorSource({
      format: new GeoJSON
    })
    const tjaleLayer = new VectorLayer({
      visible: true,
      source: this.tjalesource
    });
    this.Map = new Map({
      layers: [mapserverLayer,tjaleLayer],
      target: 'tjaldjup_map',
      view: new View({       
        projection: proj_sweref99tm,        
        center: this.center,
        enableRotation: false,
        zoom: 0
      }),
      controls: DefaultControls({
        attributionOptions: ({
          collapsible: true,
          collapsed: true,
          label: ''
          
        })
      }).extend([
        new ScaleLine({}),
      ]),
    });
    this.selectInteraction = this.createSelectinteraction();
    this.Map.addInteraction(this.selectInteraction);    
    this.getStationDatafromServer();
  }

  private createSelectinteraction(): Select {
    // select interaction working on "click"
    var selectinteraction = new Select({
      condition: click,
      hitTolerance: 10
    });

    selectinteraction.on('select', this.zone.run(() => function (e: SelectEvent) {
      var maetpunktId: number = 0;
      var eventService = null;
      this.selectedFeatures = e.selected;
      var deselected = e.target.getLayer(this.selectedFeatures[0]).getSource().getFeatures().filter(p => p.get('maetpunktid') != this.selectedFeatures[0].get('maetpunktid'));

      this.selectedFeatures.forEach(function (feature) {
        var olmapsymbol = new OlMapSymbol();
        var styles = olmapsymbol.createSymbol(feature);
        var selectedstyle = olmapsymbol.createselectedSymbol(feature);
        styles.push(selectedstyle);
        feature.setStyle(styles);
        maetpunktId = feature.get('maetpunktid');
        eventService = feature.get('eventService');
      });

      deselected.forEach(function (feature) {
        var olmapsymbol = new OlMapSymbol();
        var styles = olmapsymbol.createSymbol(feature);
        feature.setStyle(styles);
      });
      if (eventService != null) {
        eventService.onmapSelection(maetpunktId);
      }
    }));

   
    return selectinteraction;
  }

  setselectedFeatures(maetpunktId: number): Feature {
    var eventService = null;
    this.selectedId = maetpunktId;
    var selected = this.tjalesource.getFeatures().filter(p => p.get('maetpunktid') == maetpunktId);
    var deselected = this.tjalesource.getFeatures().filter(p => p.get('maetpunktid') != maetpunktId);
    this.selectedFeatures = selected;
    deselected.forEach(function (feature) {
      var olmapsymbol = new OlMapSymbol();
      var styles = olmapsymbol.createSymbol(feature);
      feature.setStyle(styles);
    });
    this.selectedFeatures.forEach(function (feature) {
      var olmapsymbol = new OlMapSymbol();
      var styles = olmapsymbol.createSymbol(feature);
      var selectedstyle = olmapsymbol.createselectedSymbol(feature);
      styles.push(selectedstyle);
      feature.setStyle(styles);
      // maetpunktId = feature.get('maetpunktid');
    });
    // this.selectedId=maetpunktId;   
    return this.selectedFeatures[0];
  }

  centermaponFeature(feature: Feature) {
    var extent = feature.getGeometry().getExtent();
    var point = olExtent.getCenter(extent);

    this.Map.getView().setCenter(point);
    this.Map.getView().setZoom(4);
  }

  stationObservable = {
    next: (res: IFrostMeasurementStation[]) => { this.frostmeasurementstations = res; this.updatetjaleFeatures(this.frostmeasurementstations); },
    error: (e: Error) => console.log("stations not  retrieved. " + e),
    complete: () => console.log("stations  retrieved")
  };

  getStationDatafromServer() {
    this.frostmeasurementService.getStations('stations')
      .subscribe(this.stationObservable);
  }

  getFeaturesfromMap() {
    return this.tjalesource.getFeatures();
  }

  getfrostmeasurmentSymbolURL(maetpunktId: number) {
    return environment.serverUrl + this.symbolUrl + maetpunktId.toString();
  }

  updatetjaleFeatures(frostmeasurementStations: IFrostMeasurementStation[]) {
    var i = 0;
    this.tjalesource.clear();
    for (i = 0; i < frostmeasurementStations.length; i++) {
      var feature = this.createFeature(frostmeasurementStations[i]);
      feature.set('source', this.tjalesource);
      feature.set('eventService', this.olmapselection);
      this.tjalesource.addFeature(feature);
    }
    var maetpunktId: number = 0;

    if (this.selectedId != undefined && this.selectedId != null && this.selectedId >= 0) {
      maetpunktId = this.selectedId;
      console.log("SelectId set");
    }
    else {
      if (frostmeasurementStations.length > 0) {
        maetpunktId = frostmeasurementStations[0].maetpunktId;
        console.log("maetpunktId=" + maetpunktId);
      }
    }
    this.onselectStationfromListorUpdate(maetpunktId);
  }

  createFeature(frostmeasurementStation: IFrostMeasurementStation) {
    var feature = new Feature({
      geometry: new Point([frostmeasurementStation.position.eastWest, frostmeasurementStation.position.northSouth]),
      name: frostmeasurementStation.name,
      maetpunktid: frostmeasurementStation.maetpunktId,
      id: frostmeasurementStation.id,
      description: frostmeasurementStation.description,
      iconSymbolURL: this.getfrostmeasurmentSymbolURL(frostmeasurementStation.maetpunktId)
    })
    var olmapsymbol = new OlMapSymbol();
    var styles = olmapsymbol.createSymbol(feature);
    feature.setStyle(styles);
    return feature;
  }

  onselectStationfromListorUpdate(maetpunktId) {
    this.selectedId = maetpunktId;
    var selectedFeature = this.setselectedFeatures(maetpunktId);
    this.centermaponFeature(selectedFeature);
    this.olmapselection.onmapSelection(maetpunktId);
  }
}



